import { InputItem, List, WhiteSpace, Button, Toast } from "antd-mobile-v2";
import React, { Component } from "react";
import { createForm } from "rc-form";
import "./index.less";
import { get, headerGet, post, postRaw } from "../../api/service/services";
import allUrl from "../../api/allUrl";
import tool from "../../api/tool";
import sectioValue from "../../api/service/secsstion";
const tabs = [{ title: "账号登录" }, { title: "短信登录" }];
const Item = List.Item;
class Cancelation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 60,
      flagCode: true,
    };
  }
  // 获取验证码
  isPhone = () => {
    const { flagCode } = this.state;
    let phoneS = this.props.form.getFieldValue("phoneNumber");
    if (!phoneS) {
      Toast.fail("请输入手机号", 1);
      return;
    }
    if (!flagCode) {
      return;
    }
    get(allUrl.register.getIsPhoneCode, { phone: phoneS })
      .then((res) => {
        if (res.success === true && res.code == 200) {
          this.countDown();
        } else {
          Toast.fail(res.msg, 1);
        }
      })
      .catch((error) => {
        Toast.fail("验证码获取失败");
      });
  };
  // 倒计时
  countDown = () => {
    const { count, flagCode } = this.state;
    let timer = null;
    let num = count;
    this.setState({
      flagCode: false,
    });
    timer = setInterval(() => {
      if (num <= 1) {
        clearInterval(timer);
        num = 60;
        this.setState({
          flagCode: true,
        });
      }
      num--;
      this.setState({
        count: num,
      });
    }, 1000);
  };
  validateAccount = (rule, value, callback) => {
    if (value && value.length > 4) {
      callback();
    } else {
      callback(new Error("At least four characters for account"));
    }
  };
  // 数据提交
  onSubmit = () => {
    this.props.form.validateFields({ force: true }, (error, values) => {
      if (error) {
        let errorData = Object.keys(error)[0];
        Toast.info(error[errorData].errors[0].message, 1);
        return;
      }
      this.removeUser(values);
    });
  };
  // 注销账号
  removeUser = (values) => {
    const { setModal } = this.props;
    postRaw(
      allUrl.register.deleteUser,
      {
        phoneNumber: values.phoneNumber,
        userCode: sectioValue.get("acount"),
      },
      {
        "Content-Type": "application/x-www-form-urlencoded",
        "Captcha-SMS-Code": this.props.form.getFieldValue("phoneCode"),
      }
    )
      .then((res) => {
        if (res.success === true && res.code == 200) {
          Toast.success("注销成功", 1, () => {
            sectioValue.remove("token");
            sectioValue.remove("acount");
            sectioValue.remove("user_id");
            sectioValue.remove("nick_name");
            sectioValue.remove("refstoken");
            sectioValue.remove("tokenTime");
            tool.remove("userInfoData");
            this.props.props.history.push("/");
          });
          setModal(false);
        } else {
          Toast.fail(res.msg, 1);
        }
      })
      .catch((error) => {
        if (error.data && error.data.msg) {
          Toast.fail(error.data.msg, 1);
        } else {
          Toast.fail("注销失败", 1);
        }
      });
  };
  render() {
    const { setModal } = this.props;
    const { getFieldProps, getFieldError } = this.props.form;
    const { flagCode, count } = this.state;
    return (
      <div className="caceltion-wrap">
        <form>
          <InputItem
            {...getFieldProps("phoneNumber", {
              // initialValue: 'little ant',
              rules: [
                { required: true, message: "请输入手机号码" },
                {
                  required: false,
                  pattern: new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/, "g"),
                  message: "请输入正确的手机号",
                },
              ],
            })}
            clear
            error={!!getFieldError("phoneNumber")}
            placeholder="请输入手机号码"
          >
            手机号码
          </InputItem>
          <WhiteSpace />
          <div style={{ position: "relative" }}>
            <InputItem
              {...getFieldProps("phoneCode", {
                rules: [{ required: true, message: "请输入验证码" }],
              })}
              clear
              placeholder="请输入验证码"
            >
              验证码
            </InputItem>
            <div
              className="code-image"
              onClick={() => {
                this.isPhone();
              }}
              style={{
                borderColor: flagCode ? "#337fd3" : "#ccc",
                color: flagCode ? "#337fd3" : "#ccc",
              }}
            >
              {flagCode ? "获取验证码" : `${count}S重新获取`}
            </div>
          </div>
          <WhiteSpace />
          <WhiteSpace />
          <WhiteSpace />
          <Item>
            <Button
              type="primary"
              inline
              onClick={() => {
                this.onSubmit();
              }}
              style={{ height: "0.35rem", lineHeight: "0.35rem" }}
            >
              确定
            </Button>
            <Button
              type="primary"
              inline
              onClick={() => {
                setModal(false);
              }}
              style={{ height: "0.35rem", lineHeight: "0.35rem" }}
            >
              取消
            </Button>
          </Item>
        </form>
      </div>
    );
  }
}

export default createForm()(Cancelation);
